import ApiIndex from "~components/reference/api/api-index/api-index";
import * as React from 'react';
export default {
  ApiIndex,
  React
};